export default __webpack_public_path__ + "static/our-tiny-home-sleeping-008e6a7f8acff71fc4fb2cba4c0f85ba.png";